import { createFileRoute, redirect } from "@tanstack/react-router";
import { getCurrency, getLocale } from "@coras-io/embed/helpers";
import type { SiteCurrency, SiteLocale } from "@coras-io/static";
import { site } from "../config";

function landingLocale(): SiteLocale {
  const detected = site.detectLocale ? getLocale(site.locale) : site.locale;
  return (site.locales as readonly string[]).includes(detected)
    ? (detected as SiteLocale)
    : site.locale;
}

function landingCurrency(locale: string): SiteCurrency {
  const detected = site.detectCurrency ? getCurrency(locale) : site.currency;
  return (site.currencies as readonly string[]).includes(detected)
    ? (detected as SiteCurrency)
    : site.currency;
}

export const Route = createFileRoute("/")({
  loader: () => {
    const locale = landingLocale();

    throw redirect({
      to: "/$locale/$currency",
      params: { locale, currency: landingCurrency(locale) },
      statusCode: 307,
      replace: true,
    });
  },
});
